import { ChevronUp, ChevronDown } from 'lucide-react';

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
};

export const SortableHeader = ({ field, label, sortState, setSortState, align = 'left' }) => (
  <th
    className={`text-${align} p-3 text-xs font-bold uppercase tracking-wider text-slate-600 cursor-pointer hover:bg-slate-200`}
    onClick={() => {
      if (sortState.field === field) {
        setSortState({ field, dir: sortState.dir === 'asc' ? 'desc' : 'asc' });
      } else {
        setSortState({ field, dir: 'asc' });
      }
    }}
  >
    <div className={`flex items-center ${align === 'right' ? 'justify-end' : ''} gap-1`}>
      {label}
      {sortState.field === field && (
        sortState.dir === 'asc' ? <ChevronUp className='w-3 h-3' /> : <ChevronDown className='w-3 h-3' />
      )}
    </div>
  </th>
);

export const sortAndFilter = (entries, sortState, filter, filterFields) => {
  if (!entries) return [];

  let result = [...entries];

  if (filter) {
    const lowerFilter = filter.toLowerCase();
    result = result.filter(entry =>
      filterFields.some(field =>
        String(entry[field] || '').toLowerCase().includes(lowerFilter)
      )
    );
  }

  result.sort((a, b) => {
    let aVal = a[sortState.field];
    let bVal = b[sortState.field];

    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return sortState.dir === 'asc' ? aVal - bVal : bVal - aVal;
    }

    aVal = String(aVal || '');
    bVal = String(bVal || '');
    return sortState.dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
  });

  return result;
};
